<div class="ols-selectie">
  <div class="ols-textbox">
    <input type='text' name='filter' (keyup)="onKey($event)" [(ngModel)]="filter" placeholder="{{placeholder}}">
    <div class="ols-icon ols-icon-filter"></div>
    <span *ngIf="filter.length > 0" class="ols-icon ols-icon-close ial-fu_018" (click)="wisFilter()"></span>
  </div>

  <ul class="ols-selectie__radio">
    <li *ngFor="let item of gefilterdeItems" (click)="clicked(item.code, item.omschrijving)" [ngClass]="[selectedCode == item.code ? 'selected' : '']">
      <div class="circle">
        <div class="outer">
          <div class="inner"></div>
        </div>
      </div>
      <div class="ols-content">
        <div class="ols-heading-5">{{item.titel}}</div>
        <div *ngIf="item.omschrijving" class="ols-subtext">{{item.omschrijving}}</div>
      </div>
    </li>
  </ul>
</div>
<p class="error-block" *ngIf="submitClicked && selectedCode === ''">Maak alsjeblieft een keuze</p>